/* eslint-disable @typescript-eslint/no-explicit-any */
import { LockClosedIcon } from '@heroicons/react/20/solid';
import { useLocation } from 'react-router-dom';

export function UnauthorizedPage() {
  const location = useLocation();

  return (
    <div className="grid max-w-screen-lg grid-cols-1 place-items-center gap-12 p-6 lg:grid-cols-2 lg:gap-24">
      <div className="absolute p-6 opacity-20 lg:static lg:opacity-100">
        <LockClosedIcon className="w-60 h-60 fill-secondary" />
      </div>
      <div className="z-2 text-center lg:text-left flex flex-col">
        <p className="mt-4 text-7xl font-bold text-secondary dark:text-accent lg:mt-0">401</p>
        <p className="mt-6 text-xl font-semibold text-slate-800 dark:text-navy-50 lg:mt-10 lg:text-3xl">
          Página não autorizada.
        </p>
        <p className="pt-2 text-slate-500 dark:text-navy-200 lg:text-lg">
          Esta página não estar autorizada para seu perfil!
        </p>
        <code className="bg-slate-300 py-3 w-full my-3 px-1 rounded-lg">
          {(location as any).state.from.pathname}
        </code>
        {/* <button
          onClick={() => {
            navigate(PageMap.cad);
          }}
          className="btn mt-10 h-11 bg-primary text-base font-medium text-white hover:bg-primary-focus hover:shadow-lg hover:shadow-primary/50 focus:bg-primary-focus focus:shadow-lg focus:shadow-primary/50 active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:hover:shadow-accent/50 dark:focus:bg-accent-focus dark:focus:shadow-accent/50 dark:active:bg-accent/90">
          Back To Home
        </button> */}
      </div>
    </div>
  );
}
